// Scope these styles to page filters; modal forms keep their own layout.
export const filterGridSx = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 280px), 1fr))",
  maxWidth: 1128, gap: 3, alignItems: "start", minWidth: 0,
  "& > *": { minWidth: 0, width: "100%", maxWidth: 360, margin: "0 !important" },
  "& .MuiFormControl-root": { minWidth: "0 !important", width: "100%", maxWidth: 360, height: "auto !important", top: "auto !important" },
  "& p": { position: "static !important", width: "auto !important", margin: "0 0 6px", padding: "0 !important", background: "transparent !important", color: "text.secondary", fontSize: "12px !important", fontWeight: 500, lineHeight: "18px" },
  "& .MuiInputLabel-root": { position: "static", transform: "none", maxWidth: "100%", mb: "6px", color: "text.secondary", fontSize: 12, fontWeight: 500, lineHeight: "18px", pointerEvents: "auto" },
  "& .MuiInputLabel-root.Mui-error": { color: "error.main" },
  "& .MuiOutlinedInput-root": { minHeight: 58, bgcolor: "background.paper" },
  "& .MuiOutlinedInput-notchedOutline": { top: 0 },
  "& .MuiOutlinedInput-notchedOutline legend": { display: "none" },
  "& .MuiFormHelperText-root": { mx: 0 },
}
export const filterActionsSx = { display: "flex", flexWrap: "wrap", gap: 1.5, my: 3 }
